var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column flex-grow-1",attrs:{"id":"app"}},[_c('div',[_c('custom-navbar'),_c('router-view')],1),_c('custom-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }